import { Component, OnInit } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Subject } from 'rxjs'

@Component({
  selector: 'app-notify-modal',
  templateUrl: './notify-modal.html',
  standalone: false
})
export class NotifyModalComponent implements OnInit {
  title = ''
  message = ''
  onClose: Subject<boolean>

  constructor(public modalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.onClose = new Subject<boolean>()
  }

  confirm(): void {
    this.modalRef.hide()
    this.onClose.next(false)
    this.onClose.complete()
  }
}
